import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Upload } from 'components';
import { useLang } from '../PlayerRegistration';
import './style.scss';

export const Step6 = () => {
  const { lang, t } = useLang();

  return (
    <Layout className="player-registration__step-6">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_6')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_6')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8} className="image-content">
        <Col xs={24} md={{ flex: '200px' }}>
          <Upload
            listType="picture"
            language={lang}
            name="id_image"
            label={t('label_photo_id')}
            rules={[{ required: true, message: t('error_photo_id') }]}
          />
        </Col>
        <Col xs={24} md={{ flex: '240px' }}>
          <ul className="photo-requirements">
            <li>{t('text_image_document')}</li>
            <li>{t('text_image_max_10mb')}</li>
            <li>{t('text_image_format')}</li>
          </ul>
        </Col>
      </Row>
    </Layout>
  );
};
